import campaignsApi from 'common/src/modules/campaigns/campaigns.api';
import {ConditionCategory} from 'common/src/modules/conditions/conditions.types';
import {sharedCampaigns} from '@cl/shared';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {DTProductSelectionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {ProductType} from 'common/src/modules/products/products.enums';
import {conditionCategoryData} from 'common/src/modules/conditions/conditions.consts';

export default async function getSignalsMetadata(
  conditionField: string,
  campaignId: number,
  versionId: number,
) {
  const signals = await campaignsApi.getSignalsByNameForConditionCard(
    conditionField,
    campaignId,
    versionId,
  );

  // Filter signals based on feeds in the campaign
  const nodes = sharedCampaigns.nodesRef.value;
  const requiredCategories: ConditionCategory[] = [];

  for (const node of Object.values(nodes)) {
    if (node.type === NodeType.PRODUCTS) {
      const productNode = node as DTProductSelectionNode;

      if (productNode.feed?.productType !== undefined) {
        const productType = productNode.feed.productType;

        if (productType === ProductType.Ecommerce) {
          requiredCategories.push(ConditionCategory.Ecommerce);
        } else if (productType === ProductType.Car) {
          requiredCategories.push(ConditionCategory.Car);
        } else if (productType === ProductType.Flight) {
          requiredCategories.push(ConditionCategory.Flight);
        }
      }
    }
  }

  let filteredSignals = signals;

  if (requiredCategories.length > 0) {
    filteredSignals = signals.filter((signal) => {
      return signal.categories.some((category) => requiredCategories.includes(category));
    });

    // If no signals remain after filtering, return the original list
    if (filteredSignals.length === 0) {
      filteredSignals = signals;
    }
  }

  const signalsMetadata = filteredSignals.map((signal) => ({
    signalKey: signal.value,
    signalName: signal.name,
    categories: (signal.categories || []).map((category) => {
      const categoryData = conditionCategoryData[category as ConditionCategory];

      return {
        value: categoryData.value,
        title: categoryData.title,
      };
    }),
    signalType: signal.type,
    optionalValues: (signal.optionalValues || []).map((optionalValue) => ({
      displayName: optionalValue.name,
      value: optionalValue.value,
    })),
    strictOptionalValues: signal.strictOptionalValues,
    optionalOperators: signal.optionalOperators,
    shouldQueryOptionalValues: signal.shouldQueryOptionalValues || false,
  }));

  return signalsMetadata;
}
